export default "__VITE_ASSET__7125cebb__"